<template>
  <section class="table-section">
    <b-table
      :data="tableData"
      hoverable
      :paginated="true"
      :per-page="10"
      :default-sort="['matchScore', 'desc']"
    >
      <template slot-scope="props">
        <b-table-column field="firstName" label="First Name" :searchable="true">
          {{ props.row.firstName }}
        </b-table-column>
        <b-table-column field="gender" label="Gender">
          {{ props.row.gender }}
        </b-table-column>
        <b-table-column field="jobTitle" label="Job Title" :searchable="true">
          {{ props.row.jobTitle }}
        </b-table-column>
        <b-table-column field="industry" label="Industry" :searchable="true">
          {{ props.row.industry }}
        </b-table-column>
        <b-table-column
          field="matchScore"
          label="Match Score"
          sortable
          centered
          numeric
        >
          <span
            :class="[
              'tag',
              { 'is-success': props.row.matchScore >= 80 },
              {
                'is-warning':
                  props.row.matchScore < 80 && props.row.matchScore >= 50,
              },
              { 'is-danger': props.row.matchScore < 50 },
            ]"
          >
            {{ props.row.matchScore }}
          </span>
        </b-table-column>
      </template>
    </b-table>
  </section>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.table-section {
  margin-top: 30px;
}
</style>
